import type { CSSProperties } from "react";
import "../styles/academy-effects.css";

/** Light particles are layered independently of the artwork, so the scene has actual depth and motion. */
export function AcademyParticles({ className = "" }: { className?: string }) {
  return (
    <span className={`academy-magic-particles ${className}`} aria-hidden="true" data-academy-effect="true">
      {Array.from({ length: 14 }, (_, index) => (
        <i
          key={index}
          style={
            {
              "--spark-x": `${(index * 29 + 7) % 97}%`,
              "--spark-y": `${(index * 17 + 12) % 94}%`,
              "--spark-delay": `${index * -0.71}s`,
              "--spark-duration": `${6 + (index % 5)}s`,
              "--spark-drift": `${index % 2 ? 28 : -24}px`,
            } as CSSProperties
          }
        />
      ))}
    </span>
  );
}
